import { tns } from 'tiny-slider/src/tiny-slider';
import { initFootnotes } from '../components/footnotes';
import initSearchField from '../components/search';
import { Popover } from 'bootstrap';
import AOS from 'aos';

export default {
  init() {
    // JavaScript to be fired on all pages

    let menuBtn = document.getElementById('menuButton');
    let siteNav = document.getElementById('siteNav');
    let pageWrapper = document.querySelector('.sbn-wrapper');

    let searchInput = document.querySelector('.search-field');
    let resultsList = document.querySelector('.search-results__list');
    let searchcontainer = document.body.querySelector('.site-nav__search');
    let mainTextElement = document.body.querySelector('#blocksContent');
    let resetSearchButton = document.querySelector('.search-results__back');

    let pageCover = document.querySelector('.page-cover');

    let aosFadeBlocks = document.body.querySelectorAll('#blocksContent .aos-fade');

    aosFadeBlocks.forEach( x => x.setAttribute('data-aos','fade'));

    AOS.init();

    if (pageCover !== null) {

      let coverDistanceToTop = pageCover.getBoundingClientRect().top,
          coverHeight = pageCover.getBoundingClientRect().height,
          coverBottomDistanceToTop = coverHeight + coverDistanceToTop,
          coverIsVisible = (coverBottomDistanceToTop < 40) ? false : true;

      if (coverIsVisible && !siteNav.classList.contains('nav-top')) {
        siteNav.classList.add('nav-top');
      } else if (!coverIsVisible && siteNav.classList.contains('nav-top')) {
        siteNav.classList.remove('nav-top');
      }

      window.addEventListener('scroll', function() {
        coverDistanceToTop = pageCover.getBoundingClientRect().top,
        coverHeight = pageCover.getBoundingClientRect().height,
        coverBottomDistanceToTop = coverHeight + coverDistanceToTop;

        if (coverBottomDistanceToTop < 40 && coverIsVisible == true) {
          coverIsVisible = false;
          if (siteNav.classList.contains('nav-top')) {
            siteNav.classList.remove('nav-top');
          }
        } else if (coverBottomDistanceToTop >= 40 && coverIsVisible == false) {
          coverIsVisible = true;
          if (!siteNav.classList.contains('nav-top')) {
            siteNav.classList.add('nav-top');
          }
        }

      });

    }

    // eslint-disable-next-line no-undef
    let solutionsArray = solutions_json;

    // eslint-disable-next-line no-undef
    let chaptersArray = chapters_json;

    // eslint-disable-next-line no-undef
    let pagesArray = pages_json;

    let totalArray;

    if (typeof(solutionsArray) === 'object' && typeof(chaptersArray) === 'object') {
      totalArray = [...solutionsArray, ...chaptersArray];
    }

    if (typeof(pagesArray) === 'object') {
      totalArray = [...totalArray, ...pagesArray];
    }

    let searchData = totalArray;

    let searchOptions = {
      isCaseSensitive: false,
      includeScore: true,
      shouldSort: true,
      includeMatches: true,
      findAllMatches: true,
      minMatchCharLength: 2,
      threshold: 0.1,
      ignoreLocation: true,
      keys: [
        'content',
      ],
    };

    if (searchData !== null && searchOptions !== null && searchInput !== null) {
      initSearchField (
          searchData,
          searchOptions,
          searchInput,
          resultsList,
          searchcontainer,
          mainTextElement,
          resetSearchButton
      )
    }

    searchInput.addEventListener('click', function() {
      if(searchcontainer.classList.contains('search-hidden')){
        searchcontainer.classList.remove('search-hidden');
      }
      if(this === document.activeElement) {
        if(!searchcontainer.classList.contains('focus')) {
          searchcontainer.classList.add('focus');
        }
      }
    });

    searchInput.addEventListener('focusout', function () {
      if(searchcontainer.classList.contains('focus')) {
        searchcontainer.classList.remove('focus');
      }
    });

    document.addEventListener('click', function(event) {
      if (searchcontainer !== event.target && !searchcontainer.contains(event.target)) {
        if(!searchcontainer.classList.contains('search-hidden')){
          searchcontainer.classList.add('search-hidden');
        }
      }
    });

    initFootnotes('#pageMainContent a[href^="#nota_"]');

    menuBtn.addEventListener('click', function() {
      if(siteNav.classList.contains('open')){
        siteNav.classList.remove('open');
        pageWrapper.classList.remove('nav-open');
      } else {
        siteNav.classList.add('open');
        pageWrapper.classList.add('nav-open');
        // AOS.refresh();
      }
    });

    let menuGalleryList = [].slice.call(document.querySelectorAll('.menu-item.gallery .sub-menu'));

    menuGalleryList.map(function(carousel) {
      let carouselContainer = carousel.closest('.gallery');
      let prevButton = carouselContainer.querySelector('.gallery_prev');
      let nextButton = carouselContainer.querySelector('.gallery_next');
      console.log(prevButton);
      return tns({
          container: carousel,
          items: 2,
          loop: false,
          controls: true,
          navPosition: 'bottom',
          controlsContainer: false,
          slideBy: 'page',
          mouseDrag: true,
          gutter: 16,
          nav: true,
          prevButton: prevButton,
          nextButton: nextButton,
          responsive: {
            768: {
              items: 2,
            },
          },
      });
    });



    let mapMarkersList = [].slice.call(document.querySelectorAll('.sbn-map-solution[data-bs-toggle="popover"]'));

    mapMarkersList.map(function (mapMarker) {

      let mapContainer = mapMarker.parentNode.closest('.sbn-integrated-map__map-column');

      let solutionTitle = mapMarker.getAttribute('data-solution-title'),
          solutionType = mapMarker.getAttribute('data-solution-type'),
          solutionLinkText = mapMarker.getAttribute('data-solution-link-text'),
          solutionLinkUrl = mapMarker.getAttribute('data-solution-link-url');

      let linkMarkup = (solutionLinkUrl !== '') ?
        `<a class="marker-popover__link" href="${ solutionLinkUrl }">${ solutionLinkText }</a>` :
        '';

      let solutionPopoverTemplate = `
        <div class="popover marker-popover shadow-lg" role="tooltip">
          <div class="popover-arrow marker-popover__arrow solution-border--${solutionType}"></div>
          <div class="popover-body marker-popover__content solution-border--${solutionType}"></div>
        </div>`;

      let solutionContent = `
        <label class="marker-popover__label solution-border--${solutionType}">Tipo ${ solutionType }</label>
        <h6 class="marker-popover__title">
          ${ solutionTitle }
        </h6>
        ${ linkMarkup }`;

      let popoverAllowList = Popover.Default.allowList;

      popoverAllowList.label = [];
      popoverAllowList.div = ['data-solution-color'];

      return new Popover(mapMarker, {
        boundary: mapContainer,
        container: mapContainer,
        content: solutionContent,
        html: true,
        trigger: 'focus',
        allowList: popoverAllowList,
        template: solutionPopoverTemplate,
      })
    });

    let nbsMaps = [].slice.call(document.querySelectorAll('.sbn-integrated-map'));

    nbsMaps.map(function (map) {
      let nextButton = map.querySelector('.sbn-integrated-map__nav-button.next');
      let prevButton = map.querySelector('.sbn-integrated-map__nav-button.prev');
      let mapSlider = map.querySelector('.sbn-integrated-map__map-container');

      nextButton.addEventListener('click', function() {
        mapSlider.setAttribute('data-active-slide', '2');
        if(!nextButton.classList.contains('active')) {
          nextButton.classList.add('active');
        }
        prevButton.classList.remove('active');
      });

      prevButton.addEventListener('click', function() {
        mapSlider.setAttribute('data-active-slide', '1');
        if(!prevButton.classList.contains('active')) {
          prevButton.classList.add('active');
        }
        nextButton.classList.remove('active');
      });

    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js